import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { AtomPageLoader } from 'components/atoms';
import OrganismTestPanel from '../../components/organism/TestPanel';

import {
	getCategoryQuestion,
} from '@store/actions/category';
import alert from '../../utility/Alert';
import {getSessionDoingExercise} from "@store/actions/exercise";

const ExerciseDetail = () => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);

	const prepareExercise = async () => {
		try {
			setLoading(true);
			Promise.all([
				dispatch(getCategoryQuestion()),
				dispatch(getSessionDoingExercise())
			]);
			setLoading(false);
		} catch (error) {
			alert.error(error.message);
		}
	};

	useEffect(() => {
		(async () => {
			prepareExercise();
		})();
	}, []);

	return loading ? <AtomPageLoader /> : <OrganismTestPanel />;
};

export default ExerciseDetail;
